var React = require('react');
var UnicornCelebration = require('./UnicornCelebration');
var useUnicornCelebration = require('./useUnicornCelebration');

/**
 * UnicornCelebrationContainer
 *
 * Container component that:
 * 1. Uses the useUnicornCelebration hook to manage state
 * 2. Renders the UnicornCelebration overlay when active
 * 3. Handles all Redux integration internally
 *
 * Mount this component at the root level (e.g., in Main.jsx)
 */
var UnicornCelebrationContainer = function () {
  var celebration = useUnicornCelebration();

  // Don't render anything if celebration is not active
  if (!celebration.isActive) {
    return null;
  }

  return React.createElement(UnicornCelebration, {
    isActive: celebration.isActive,
    isFadingOut: celebration.isFadingOut,
    unicorns: celebration.unicorns,
    onDismiss: celebration.dismiss,
    onUnicornComplete: celebration.handleUnicornComplete,
  });
};

module.exports = UnicornCelebrationContainer;
